const normalizeUrl = (value = '') => value.trim().replace(/\/$/, '');

const DEFAULT_API_URL = 'https://mutawirstudios-api.onrender.com';

const envUrl = process.env.REACT_APP_BACKEND_URL;

export const API_BASE_URL = normalizeUrl(envUrl || DEFAULT_API_URL);

export default API_BASE_URL;
